import axios from 'axios'
import * as MutationTypes from '@/store/mutation-types'
import { load_one } from '@/store/action-helpers'

// noinspection JSUnusedGlobalSymbols
export default {

    create({ dispatch }, { productId, model, isInternal = false }) {
        const type = isInternal ? 'internal' : 'purchaser'

        return axios.post(`/api/v1/products/${productId}/specimen-copies/${type}`, model).then(response => {
            return Promise.all([
                // Produkt neu laden
                dispatch('products/loadOne', { id: productId, force: true }, { root: true }),

                // Belegkopie laden
                dispatch('loadOne', { id: response.data.id, force: true })
            ])
        })
    },

    loadOne: load_one('specimen-copies/:id'),

    remove({ commit }, { model }) {
        return axios.delete(`/api/v1/specimen-copies/${model.id}`, model).then(() => {
            commit(MutationTypes.REMOVE, { content: model })
        })
    },


    update({ dispatch }, { model }) {
        return axios.put(`/api/v1/specimen-copies/${model.id}`, model).then(() => {
            // Belegkopie neu laden
            return dispatch('loadOne', { id: model.id, force: true })
        })
    },

}
